var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title flex-between-center"},[_c('div',{staticClass:"flex-center"},[_c('div',{staticClass:"cloume-line"}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))]),_vm._t("left")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }